export default __webpack_public_path__ + "static/media/gallery-2.71f76dc8.jpg";